module.exports = __webpack_public_path__ + "static/private_office_4-4d08781d441bab014c133d4093e3507e.jpg";